import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "table-header" }
const _hoisted_2 = { nowrap: "" }
const _hoisted_3 = { nowrap: "" }
const _hoisted_4 = { class: "table-header" }
const _hoisted_5 = { nowrap: "" }
const _hoisted_6 = { nowrap: "" }

import i18n from '@/lang/i18n';

export default /*@__PURE__*/_defineComponent({
  __name: 'HeaderRow',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("tr", _hoisted_1, [
      _createElementVNode("td", _hoisted_2, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.restraintTimeByDay')), 1),
      _createElementVNode("td", _hoisted_3, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.restraintDays')), 1)
    ]),
    _createElementVNode("tr", _hoisted_4, [
      _createElementVNode("td", _hoisted_5, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.averageGoal')), 1),
      _createElementVNode("td", _hoisted_6, _toDisplayString(_unref(i18n).global.t('pages.monthlyReportWorkingTimesSetting.header.actualAssumption')), 1)
    ])
  ], 64))
}
}

})